/**
 * `/onboarding` — «Nuova azienda»: il Master crea l'azienda di un cliente. La pagina vive in
 * `src/features/onboarding/`. Il vecchio `/setup` atterra qui.
 *
 * Fino al 02-11-2026 la query portava `nuova=1` e `creata=1`, i due segnali fra la creazione e la
 * lista di controllo: la lista non c'è più, e i parametri si ignorano.
 */
import { createFileRoute } from '@tanstack/react-router';
import { OnboardingWizard } from '@/features/onboarding/OnboardingWizard';

export const Route = createFileRoute('/_app/onboarding')({
  component: OnboardingWizard,
});
